<template>
  <div class="gray-back">
    <div class="mine-box-title">
      <a class="bc-od-back" href="javascript:;" @click.prevent="goList">← {{ $T('返回订单列表') }}</a>
      {{ $T('订单详情') }}
    </div>
    <div class="mine-content" v-if="order.id">
      <div class="bc-od-status">
        <div class="bc-od-status__name">{{ statusName }}</div>
        <div class="bc-od-status__note" v-if="statusNote">{{ statusNote }}</div>
        <div class="bc-od-actions">
          <el-button
            v-for="(btn, bi) in actionButtons"
            :key="'a' + bi"
            size="medium"
            :type="btn.class === 'primary' ? 'primary' : 'default'"
            @click="onAction(btn)"
          >
            {{ btnLabel(btn) }}
          </el-button>
        </div>
      </div>

      <section class="bc-od-card">
        <h3>{{ $T('收货信息') }}</h3>
        <p v-if="order.address">
          {{ order.address.name }} {{ order.address.phone || order.address.tel }}
        </p>
        <p class="gray" v-if="order.address">
          {{ formatAddress(order.address) }}
        </p>
        <p v-else class="gray">{{ $T('暂无地址信息') }}</p>
      </section>

      <section class="bc-od-card">
        <h3>{{ $T('商品信息') }}</h3>
        <div
          v-for="(g, gi) in order.items || []"
          :key="'g' + gi"
          class="bc-od-goods"
        >
          <img :src="g.pic_url" alt="" />
          <div class="bc-od-goods__meta">
            <div class="bc-od-goods__title">{{ g.title }}</div>
            <div class="gray" v-if="skuText(g)">{{ skuText(g) }}</div>
            <div class="bc-od-goods__row">
              <span>{{ money(g.price) }}</span>
              <span>× {{ g.count }}</span>
            </div>
          </div>
        </div>
        <div class="bc-od-sum">
          <span>{{ $T('观众中心运费') }}：{{ money(order.express_price || 0) }}</span>
          <span>
            {{ $T('观众中心应付') }}：
            <strong>{{ money(order.pay_price) }}</strong>
          </span>
        </div>
      </section>

      <section class="bc-od-card">
        <h3>{{ $T('订单信息') }}</h3>
        <p>{{ $T('订单号') }}：{{ order.code || order.id }}</p>
        <p>{{ $T('下单时间') }}：{{ order.create_time_str || formatTime(order.create_time) }}</p>
        <p v-if="order.pay_time_str && order.pay_time_str !== '-'">
          {{ $T('支付时间') }}：{{ order.pay_time_str }}
        </p>
        <p v-if="order.pay_type">
          {{ $T('支付方式') }}：{{ payTypeText(order.pay_type) }}
        </p>
        <div v-if="voucherPics.length" class="bc-od-voucher">
          <div class="bc-od-voucher__label">{{ $T('付款凭证') }}</div>
          <div class="bc-od-voucher__pics">
            <a
              v-for="(pic, pi) in voucherPics"
              :key="'p' + pi"
              :href="picUrl(pic)"
              target="_blank"
              rel="noopener"
            >
              <img :src="picUrl(pic)" alt="" />
            </a>
          </div>
        </div>
      </section>
    </div>
    <div v-else class="mine-content bc-od-empty">{{ $T('观众中心加载中') }}</div>

    <SpectatorOfflinePayDialog
      :show="payDialogShow"
      :ids="[order.id]"
      :pay-price="order.pay_price"
      @onPaid="onOfflinePaid"
      @onClose="payDialogShow = false"
    />
  </div>
</template>

<script>
import { Toast } from 'vant';
import SpectatorOfflinePayDialog from '@/page/mainindex/SpectatorOfflinePayDialog.vue';
import { spectatorMoney } from '@/utils/spectatorMoney';

export default {
  name: 'SpectatorOrderDetail',
  components: { SpectatorOfflinePayDialog },
  data() {
    return {
      order: {},
      payDialogShow: false,
    };
  },
  computed: {
    statusName() {
      const sb = this.order.status_buttons || {};
      return sb.name || '';
    },
    statusNote() {
      const sb = this.order.status_buttons || {};
      return sb.note || '';
    },
    actionButtons() {
      const buttons = (this.order.status_buttons && this.order.status_buttons.buttons) || [];
      return buttons.filter((b) => b.type === 'pay' || b.type === 'offline');
    },
    voucherPics() {
      const pics = this.order.offline_pay_pics;
      return Array.isArray(pics) ? pics : [];
    },
  },
  mounted() {
    document.title = this.$T('订单详情');
    this.fetch();
  },
  methods: {
    money: spectatorMoney,
    goList() {
      this.$router.push({ path: '/spectator-orders' });
    },
    formatTime(ts) {
      if (!ts) return '';
      const d = new Date(ts * 1000);
      const pad = (x) => (x < 10 ? '0' + x : '' + x);
      return (
        d.getFullYear() +
        '-' +
        pad(d.getMonth() + 1) +
        '-' +
        pad(d.getDate()) +
        ' ' +
        pad(d.getHours()) +
        ':' +
        pad(d.getMinutes())
      );
    },
    formatAddress(addr) {
      if (!addr) return '';
      const detail = addr.address || addr.addressDetail || '';
      return `${addr.province || ''}${addr.city || ''}${addr.county || ''}${detail}`;
    },
    skuText(g) {
      if (g.property_name) return g.property_name;
      if (g.sku && g.sku.sku && g.sku.sku.length) {
        return g.sku.sku
          .map((s) => (s.field || '') + ':' + (s.attr || ''))
          .filter(Boolean)
          .join(' / ');
      }
      return '';
    },
    payTypeText(type) {
      if (type === 'offline') return this.$T('线下支付');
      return type || '';
    },
    picUrl(pic) {
      if (!pic) return '';
      if (typeof pic === 'string') return pic;
      return pic.url || pic.path || '';
    },
    btnLabel(btn) {
      if (btn.type === 'pay') return this.$T('去支付');
      if (btn.type === 'offline') {
        return btn.name === '更新支付凭证'
          ? this.$T('更新支付凭证')
          : this.$T('上传支付凭证');
      }
      return btn.name;
    },
    fetch() {
      const id = this.$route.query.id;
      if (!id) {
        Toast(this.$T('观众中心订单无效'));
        this.goList();
        return;
      }
      const that = this;
      that.$api.get(
        '/api/order/orderDetail',
        { id },
        (res) => {
          that.order = res.data || {};
        },
        (res) => {
          Toast((res && res.msg) || that.$T('观众中心订单无效'));
        }
      );
    },
    onAction(btn) {
      if (btn.type === 'offline') {
        this.$router.push({
          path: '/spectator/offline-voucher',
          query: { ids: String(this.order.id), price: this.order.pay_price },
        });
        return;
      }
      if (btn.type === 'pay') {
        this.payDialogShow = true;
      }
    },
    onOfflinePaid() {
      this.payDialogShow = false;
      this.$router.push({
        path: '/spectator/offline-voucher',
        query: { ids: String(this.order.id), price: this.order.pay_price },
      });
    },
  },
};
</script>

<style scoped>
.bc-od-back {
  display: inline-block;
  margin-right: 16px;
  font-size: 14px;
  font-weight: 400;
  color: #5b6478;
  text-decoration: none;
}
.bc-od-empty {
  text-align: center;
  color: #999;
  padding: 48px 0;
}
.bc-od-status {
  background: linear-gradient(90deg, #1e2842 0%, #2d3a5c 100%);
  color: #fff;
  border-radius: 10px;
  padding: 20px 22px;
  margin-bottom: 16px;
}
.bc-od-status__name {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 6px;
}
.bc-od-status__note {
  font-size: 13px;
  opacity: 0.85;
  margin-bottom: 12px;
}
.bc-od-actions .el-button + .el-button {
  margin-left: 8px;
}
.bc-od-card {
  background: #fff;
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}
.bc-od-card h3 {
  margin: 0 0 12px;
  font-size: 15px;
  color: #1e2842;
}
.bc-od-card p {
  margin: 0 0 6px;
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
}
.gray {
  color: #9ca3af !important;
  font-size: 13px !important;
}
.bc-od-goods {
  display: flex;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;
}
.bc-od-goods img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 6px;
  background: #f3f4f6;
}
.bc-od-goods__title {
  font-size: 14px;
  font-weight: 600;
  color: #1e2842;
  margin-bottom: 4px;
}
.bc-od-goods__row {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 14px;
  color: #c2410c;
}
.bc-od-sum {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  font-size: 13px;
  color: #6b7280;
}
.bc-od-sum strong {
  color: #c2410c;
  font-size: 18px;
}
.bc-od-voucher {
  margin-top: 12px;
}
.bc-od-voucher__label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
}
.bc-od-voucher__pics {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.bc-od-voucher__pics img {
  width: 88px;
  height: 88px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}
</style>



// WEBPACK FOOTER //
// SpectatorOrderDetail.vue?39625974